var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.totalLinks > 0)?_c('div',{staticClass:"text-center"},[_c('v-pagination',{attrs:{"length":_vm.totalLinks,"total-visible":7},on:{"input":_vm.clickPage},model:{value:(_vm.page),callback:function ($$v) {_vm.page=$$v},expression:"page"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }